<template>
  <div class="content-panel">
    <div class="content-panel-close">
      <i class="os-icon os-icon-close"></i>
    </div>
    <div class="element-wrapper">
      <h6 class="element-header">
        Discord Server
      </h6>
      <iframe src="https://canary.discordapp.com/widget?id=307422842998489088&theme=dark" width="350" height="500" allowtransparency="true" frameborder="0"></iframe></br></br>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightSidebar',
  data () {
    return {
      //
    }
  },
  computed: {
    //
  },
  methods: {
    queue(gameType, type) {
      this.axios.post(`${this.API_URL}/kraken/lobbies/${this.$root.krakenLobby.id}/queue`, { gameType: gameType, type: type }).then((res) => {
        //
      })
    },
    exitQueue() {
      this.axios.post(`${this.API_URL}/kraken/lobbies/${this.$root.krakenLobby.id}/unqueue`).then((res) => {
        //
      })
    },
    acceptFriend(friend_id) {
      this.axios.post(`${this.API_URL}/kraken/friends/${friend_id}/accept`).then((res) => {
        this.$root.fetchFriends()
      })
    },
    rejectFriend(friend_id) {
      this.axios.post(`${this.API_URL}/kraken/friends/${friend_id}/reject`).then((res) => {
        this.$root.fetchFriends()
      })
    },
    removeFriend(friend_id) {
      this.axios.post(`${this.API_URL}/kraken/friends/${friend_id}/remove`).then((res) => {
        this.$root.fetchFriends()
      })
    },
    inviteLobby(user) {
      this.axios.post(`${this.API_URL}/kraken/lobbies/${this.$root.krakenLobby.id}/invite`, { user: user }).then((res) => {
        //
      })
    },
    removeLobby(user) {
      this.axios.post(`${this.API_URL}/kraken/lobbies/${this.$root.krakenLobby.id}/remove`, { user: user }).then((res) => {
        //
      })
    },
    goToMatch() {
      this.$router.push(`/kraken/match/${this.$root.krakenMatch.id}`)
    }
  },
  created() {
    //
  },
  watch: {
    //
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
